import { Routes } from '@angular/router';
import { AppLayout } from './shared/layouts/app-layout/app-layout';
import { AppRoutes } from './app/app.routes';
import { AuthRoutes } from './auth/auth.routes';

export const routes: Routes = [
  {
    path: 'app',
    component: AppLayout,
    children: AppRoutes,
  },
  {
    path: 'auth',
    children: AuthRoutes,
  },
  {
    path: '',
    redirectTo: 'app/home',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'auth/login',
  },
];
